import { render, staticRenderFns } from "./ComplaintCauseManage.vue?vue&type=template&id=63bc6302&"
import script from "./ComplaintCauseManage.vue?vue&type=script&lang=js&"
export * from "./ComplaintCauseManage.vue?vue&type=script&lang=js&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports